<template>
  <span>
    <datetime-picker
      label="Select Datetime"
      v-model="innerModelStart"
      @input="onInput"
    >
    </datetime-picker>
    <datetime-picker
      label="Select Datetime"
      v-model="innerModelEnd"
      @input="onInput"
    >
    </datetime-picker>
  </span>
</template>
<script>
import DatetimePicker from './DatetimePicker'
export default {
  name: 'datetime-range-picker',
  components: {
    DatetimePicker
  },
  data () {
    return {
      menu: false,
      menu2: false,
      innerModelStart: this.value,
      innerModelEnd: this.value
    }
  },
  methods: {
    onInput () {
      this.$emit('input', [this.innerModelStart, this.innerModelEnd])
      if (typeof this.changeCallback === 'function') {
        this.changeCallback([this.innerModelStart, this.innerModelEnd])
      }
    }
  },
  props: {
    value: [String, Number],
    label: {
      type: String
    },
    changeCallback: {
      type: Function
    }
  }
}
</script>
